require('./bootstrap');
require('./tab-navigation');
require('./country-picker');
require('./profile-edit');
require('./mission');
require('./modals');
require('./adminValidation');
require('./map');
require('./datatables');
require('./datetimepickers');
require('./alert');
// If we use vue, then include it and work with it
// require('./vue');
